import TencentCloudChat, { ChatSDK } from "@tencentcloud/chat";
import { useEffect, useState } from "react";
import { CHAT_APP_ID } from "../commons/constants";
import { REQUEST_USER_SIG } from "../commons/constants/api-urls";
import defaultAxios from "../commons/utils/axios";

interface TencentMessages {
  (userID: string): {
    userID: string;
    userSig?: string;
    chat?: ChatSDK;
  };
}

const useInitTencentMessages: TencentMessages = userID => {
  const [chat, setChat] = useState<ChatSDK>();
  const [userSig, setUserSig] = useState();

  async function getUserSig() {
    const res = await defaultAxios.get(REQUEST_USER_SIG);
    if (res.data.userSig) {
      setUserSig(res.data.userSig);
    }
    return res.data.userSig;
  }

  async function createTencentChat(userSig: string): Promise<ChatSDK> {
    return new Promise((resolve, reject) => {
      let options = {
        SDKAppID: Number(CHAT_APP_ID),
      };
      const chat = TencentCloudChat.create(options);
      chat.setLogLevel(1);

      const onReady = () => {
        resolve(chat);
      };
      chat.on(TencentCloudChat.EVENT.SDK_READY, onReady);
      chat.login({
        userID: `merchant-${userID}`,
        userSig: userSig,
      });
    });
  }

  async function getChatObject() {
    try {
      const userSig = await getUserSig();
      const chat = await createTencentChat(userSig);
      setChat(chat);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (!userID) return;
    getChatObject();
  }, [userID]);

  return {
    userID,
    userSig,
    chat,
  };
};

export default useInitTencentMessages;
